"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ControlFormTabs = void 0;
var React = require("react");
var mobx_react_1 = require("mobx-react");
var App_1 = require("../../App");
var react_tabs_1 = require("react-tabs");
var recurrenceForm_1 = require("./recurrenceForm");
var controlInformationForm_1 = require("./controlInformationForm");
var commentList_1 = require("./commentList");
var urls_1 = require("../../urls");
var referenceList_1 = require("../references/referenceList");
var generic_1 = require("../generic");
var $ = require("jquery");
var buttons_1 = require("../buttons");
var logList_1 = require("../log/logList");
var existingControlsTab_1 = require("./existingControlsTab");
var circles_1 = require("../circles");
var utils_1 = require("../../utils");
var contexts_1 = require("../../interfaces/contexts");
var api_1 = require("../../api");
var editableRows_1 = require("../editableList/editableRows");
var referenceDialog_1 = require("../references/referenceDialog");
var utils_2 = require("../references/utils");
var RiskBimMaps_1 = require("../riskPage/RiskBimMaps");
var ControlFormTabs = (function (_super) {
    __extends(ControlFormTabs, _super);
    function ControlFormTabs() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ControlFormTabs.prototype.detachFromRisk = function (risk) {
        App_1.store.controlDialog.checkDetachRisk(risk).then(function (page) { return App_1.store.controlDialog.detachRisk(risk); }, function (error) {
            var reason = JSON.parse(error.responseText);
            if (reason.confirm) {
                optionDialog(reason.confirm, [{
                        text: gettext("Retain confidentiality"),
                        "class": "btn btn-primary",
                        click: function () { return App_1.store.controlDialog.detachRisk(risk, true); }
                    }, {
                        text: gettext("Make public"),
                        "class": "btn btn-secondary",
                        click: function () { return App_1.store.controlDialog.detachRisk(risk, false); }
                    }], null, null, 500);
            }
            else {
                api_1.api.apiErrorHandler(error, null, null);
            }
        });
    };
    ControlFormTabs.prototype.detachFromCausality = function (causality) {
        App_1.store.controlDialog.detachCausality(causality);
    };
    ControlFormTabs.prototype.onDeleteReference = function (ref) {
        fancyConfirm(gettext("Do you really want to delete the reference?"), function () {
            App_1.store.referenceDialog.deleteReference(ref).then(function () {
                notification(gettext("Reference has been successfully deleted"));
                App_1.store.controlDialog.refresh();
            });
        });
    };
    ControlFormTabs.prototype.getReferenceDialogFormProps = function () {
        var formProps = App_1.store.referenceDialog.getFormProps();
        return __assign(__assign({}, formProps), { onSave: function () { return formProps.onSave().then(function () { return App_1.store.controlDialog.refresh(); }); } });
    };
    ControlFormTabs.prototype.render = function () {
        var _this = this;
        var props = this.props;
        var context = App_1.store.context.get();
        var riskId = context.risk;
        var refCircle = props.references.length ? React.createElement(circles_1.FilledCircle, null) : React.createElement(circles_1.EmptyCircle, null);
        return (React.createElement("div", { className: "ControlFormTabs" },
            React.createElement(react_tabs_1.Tabs, { selectedIndex: App_1.store.controlDialog.selectedTab, onSelect: this.changeTab.bind(this), selectedTabClassName: "active" },
                React.createElement(react_tabs_1.TabList, { className: "nav nav-tabs mb-2" },
                    React.createElement(react_tabs_1.Tab, { className: "nav-item" },
                        React.createElement("a", { className: "nav-link", href: "#0" }, get_term("Control Information"))),
                    !props.control && [
                        React.createElement(react_tabs_1.Tab, { className: "nav-item", key: 5 },
                            React.createElement("a", { className: "nav-link", href: "#0" }, get_term("Existing Controls")))
                    ],
                    props.control && [
                        React.createElement(React.Fragment, null,
                            React.createElement(react_tabs_1.Tab, { className: "nav-item", key: 1 },
                                React.createElement("a", { className: "nav-link", href: "#0" }, gettext("Relations"))),
                            React.createElement(react_tabs_1.Tab, { className: "nav-item", key: 6 },
                                React.createElement("a", { className: "nav-link", href: "#0" }, gettext("Cost"))),
                            React.createElement(react_tabs_1.Tab, { className: "nav-item", key: 2 },
                                React.createElement("a", { className: "nav-link", href: "#0" },
                                    gettext("Refs"),
                                    ".\u00A0\u00A0",
                                    refCircle)),
                            React.createElement(react_tabs_1.Tab, { className: "nav-item", key: 3 },
                                React.createElement("a", { className: "nav-link", href: "#0" }, gettext("Recurrence"))),
                            React.createElement(react_tabs_1.Tab, { className: "nav-item", key: 4 },
                                React.createElement("a", { className: "nav-link", href: "#0" }, gettext("Log"))),
                            React.createElement(react_tabs_1.Tab, { className: "nav-item", key: 7 },
                                React.createElement(RiskBimMaps_1.default, { project_id: props.control.project, type_id: props.control.id, type: 'control' })))
                    ]),
                React.createElement(react_tabs_1.TabPanel, null,
                    React.createElement(controlInformationForm_1.ControlInformationForm, { controlPut: props.controlPut, recurrence: props.recurrence, availableStatuses: props.availableStatuses, availableOwners: props.availableOwners, udf_types: props.udf_types, udf_section_header: props.udf_section_header, handleSubmit: props.handleControlInformationSubmit, handleSubmitAndClose: props.handleControlInformationSubmitAndClose, updating: props.updating, onChange: props.onChange }),
                    props.control &&
                        React.createElement(commentList_1.CommentSection, { comments: props.comments, onChange: props.onCommentChange, onSubmit: props.onCommentSubmit })),
                !props.control && [
                    React.createElement(react_tabs_1.TabPanel, { key: 5 },
                        React.createElement(existingControlsTab_1.ExistingControlTab, null))
                ],
                props.control && [
                    React.createElement(react_tabs_1.TabPanel, { key: 1 },
                        React.createElement("div", { className: "" },
                            React.createElement("div", null,
                                React.createElement("h4", { className: "ReferenceList__Header" }, get_term("This control affects these risks")),
                                React.createElement("ul", { className: "list-unstyled" }, this.props.relations ?
                                    this.props.relations.map(function (risk) {
                                        return React.createElement("li", { key: risk.id, className: "p-1 my-1 hover-highlight" },
                                            React.createElement("a", { href: "#0", onClick: function (e) { (0, utils_1.preventDefault)(e); _this.detachFromRisk(risk); }, className: "btn btn-sm btn-link float-right" },
                                                React.createElement("i", { className: "fas fa-unlink" }),
                                                " ",
                                                gettext('Detach')),
                                            React.createElement("a", { href: (0, urls_1.resolve)(urls_1.Urls.risk_detail, risk.project, risk.id), className: "RelationLink" },
                                                gettext("Risk"),
                                                " #",
                                                risk.risk_number,
                                                " ",
                                                risk.title));
                                    })
                                    :
                                        React.createElement("li", null, gettext("None")))),
                            React.createElement("div", null,
                                React.createElement("div", { className: "clear" }),
                                React.createElement(generic_1.HTMXContentAnchor, null,
                                    React.createElement("div", { "hx-get": (0, urls_1.resolve)(urls_1.Urls.control_causality_relations, props.control.project, props.control.id), "hx-trigger": "load", "hx-target": "this", "hx-swap": "innerHTML" }))))),
                    React.createElement(react_tabs_1.TabPanel, { key: 6 },
                        React.createElement(editableRows_1.EditableRowsTable, { createButtonDescription: gettext("Add cost"), rows: (0, editableRows_1.buildControlCostIRows)(props.controlCosts), emptyRow: (0, editableRows_1.buildEmptyControlCostRow)(props.control), column: (0, editableRows_1.buildControlCostColumn)(props.availableRiskTargets), canCreateRow: props.availableRiskTargets.length > 0, performRowCreate: function (obj) { return App_1.store.controlDialog.postControlCost(obj); }, performRowUpdate: function (id, values) { return App_1.store.controlDialog.updateControlCost(id, values); }, performRowDelete: function (id) { return App_1.store.controlDialog.deleteControlCost(id); }, refetchTable: function () { return App_1.store.controlDialog.refresh({ only_control_costs: true }); } })),
                    React.createElement(react_tabs_1.TabPanel, { key: 2 },
                        React.createElement(generic_1.FloatRight, null,
                            React.createElement(buttons_1.ActionButton, { className: "btn-sm", buttonRef: function (button) {
                                    bind_reference_dialog('div#control_reference_dialog_bind');
                                    $(button).off('click');
                                    $(button).click(function (e) {
                                        handleCreate(e, 'div#control_reference_dialog_bind', "#control_references_tab", "control", function () { return props.control.id; }, function () {
                                            var context = App_1.store.context.get();
                                            if (context instanceof contexts_1.ProjectContext) {
                                                $("#project_id").val(context.project);
                                                return context.project;
                                            }
                                            return null;
                                        }, function () {
                                            App_1.store.controlDialog.refresh();
                                        });
                                    });
                                } },
                                React.createElement(generic_1.Icon, { name: generic_1.Icons.plus_circle }),
                                " ",
                                gettext("Create reference"))),
                        React.createElement("div", { className: "Panel" },
                            React.createElement(referenceList_1.ReferenceList, { referredObject: utils_2.ReferenceListTypes.CONTROL, references: props.references, editable: true, deletable: true, onEditClick: App_1.store.referenceDialog.openDialog.bind(App_1.store.referenceDialog), onDeleteClick: this.onDeleteReference }),
                            React.createElement(referenceDialog_1.ReferenceDialog, { reference: App_1.store.referenceDialog.reference, isOpen: App_1.store.referenceDialog.isOpen, isReady: App_1.store.referenceDialog.isReady, onDialogClose: App_1.store.referenceDialog.closeDialog.bind(App_1.store.referenceDialog), formProps: this.getReferenceDialogFormProps() }))),
                    React.createElement(react_tabs_1.TabPanel, { key: 3 },
                        React.createElement(recurrenceForm_1.RecurrenceForm, { control: props.control, recurrence: props.recurrence, recurrenceOptions: props.availableRecurrence, onSubmit: props.handleRecurrenceSubmit.bind(this) })),
                    React.createElement(react_tabs_1.TabPanel, { key: 4 },
                        React.createElement(logList_1.LogList, { elements: props.entries }))
                ])));
    };
    ControlFormTabs.prototype.changeTab = function (index, lastIndex, event) {
        App_1.store.controlDialog.setTab(index);
        return true;
    };
    ControlFormTabs = __decorate([
        mobx_react_1.observer
    ], ControlFormTabs);
    return ControlFormTabs;
}(React.Component));
exports.ControlFormTabs = ControlFormTabs;
